import type { ActivePlanKey } from '@sparklayer-io/spark-dash-core/constants/features';
import { t } from 'i18next';
import type { ReactNode } from 'react';
import { AddonCard } from './addon-card';
import { IconCard } from './icon-card';

export type PopularAddonsItem = {
  title: string;
  image: string;
  description: string;
  link: string;
  /** Footer call-to-action, e.g. an "Upgrade" or a "Speak to our team" button. */
  cta?: ReactNode;
  /** Extra classes on the card, e.g. to hide it below a breakpoint. */
  className?: string;
} & ({ price: string; plan?: never } | { plan: ActivePlanKey; price?: never });

export function PopularAddons({ items }: { items: PopularAddonsItem[] }) {
  return (
    <div className="flex w-full flex-col gap-4 sm:gap-6">
      <IconCard
        icon="upgrade"
        title={t('components:popular_addons.title')}
        subtitle={t('components:popular_addons.subtitle')}
      />

      <div className="flex w-full flex-row flex-wrap gap-2">
        {items.map((item) => {
          const common = {
            title: item.title,
            imgSrc: item.image,
            learnMoreURL: item.link,
            cta: item.cta,
            className: item.className,
            children: item.description,
          };

          return item.plan !== undefined ? (
            <AddonCard key={item.title} {...common} plan={item.plan} />
          ) : (
            <AddonCard key={item.title} {...common} price={item.price} />
          );
        })}
      </div>
    </div>
  );
}
